<template>
  <v-app style="background-color: #F7F9FB;">
    <app-bar />
    <left-menu />
    <v-main>
      <router-view />
      <v-btn
        :class="{ opened: isSessionMenuVisible }"
        class="right-drawer-open-btn"
        color="accent"
        fab
        @click="toggleSessionMenu"
      >
        <v-icon>
          mdi-menu-left
        </v-icon>
      </v-btn>
    </v-main>
    <right-session-menu
      :value="isSessionMenuVisible"
      @add-sessions="addSessionsOpened = true"
      @input="setSessionMenu"
    />
    <ag-notify />
    <add-sessions-container :visible.sync="addSessionsOpened" />
  </v-app>
</template>

<script>
import AppBar from 'src/components/layout/AppBar'
import LeftMenu from 'src/components/layout/LeftMenu'
import AgNotify from 'src/components/common/AgNotify'
import { mapActions, mapGetters } from 'vuex'
import RightSessionMenu from '../components/RightSessionMenu'
import AddSessionsContainer from '../containers/AddSessionsContainer'

export default {
  name: 'AnimationLayout',
  components: {
    AppBar,
    LeftMenu,
    AgNotify,
    RightSessionMenu,
    AddSessionsContainer,
  },
  data: () => ({
    addSessionsOpened: false,
  }),
  computed: {
    ...mapGetters('ui', {
      isSessionMenuVisible: 'isSessionMenuVisible',
    }),
  },
  created () {
    this.loadSessionList()
    this.joinAllOpenedSessions()
  },
  methods: {
    ...mapActions('ui', {
      toggleSessionMenu: 'toggleSessionMenu',
      setSessionMenu: 'setSessionMenu',
    }),
    ...mapActions('animation', {
      loadSessionList: 'loadSessionList',
      joinAllOpenedSessions: 'joinAllOpenedSessions',
    }),
  },
}
</script>

<style lang="scss" scoped>
  .right-drawer-open-btn {
    position: absolute;
    transition: right 0.2s ease;
    right: -30px;
    top: 10px;

    &:hover {
      right: -25px;
    }

    &.opened {
      .v-icon {
        transform: rotate(180deg);
      }
    }

    .v-icon {
      margin-right: 25px;
      font-size: 36px;
    }
  }
</style>
